module.exports = __webpack_public_path__ + "static/media/sign_in_bg.3dcc7e64.svg";